import s from "styled-components";
import Paper from "_c/Paper";

export const Wrap = s(Paper)`
  margin-top: 10px;
  .simpo-select__value-container--has-value {
    overflow: visible !important;
  }
`;
export const Form = s.form`
  margin-top: 15px;
`;

export const Buttons = s.div`
  button {
    margin: 0 2px;
  }
  display: flex;
  @media(max-width: 550px) {
    margin-inline-start: auto;
  }
`;

export const Head = s.h4`
 font-size: 16px;
 font-weight: 500;
 margin: 0;
 margin-bottom: 15px;
 color: var(--font-color-accent);
`;
export const AppliedSect = s.section`
  li {
    display: flex;
  }
`;
export const CreateSect = s.section`
  margin-top: 20px;
  border-top: ${({ theme }) => theme.border.light};
`;

export const PriceBadge = s.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  min-width: 40px;
  min-height: 40px;
  background-color: var(--color-cta);
  border-radius: 50%;
  font-weight: 700;
  font-size: 14px;
  color: white;
  margin-inline-end: 5px;
`;
export const Badge = s(PriceBadge)`
  box-shadow: 0px 6px 10px var(--color-primary);
  background-color: var(--color-primary);
  transition: box-shadow .5s ease;
  cursor: help;
  :hover {
    box-shadow: 0px 6px 20px var(--color-primary);
  }
`;
export const List = s.ul``;

export const ListItem = s.li`
  display: flex;
  align-items: center;
  border-bottom: ${({ theme }) => theme.border.light};
  padding: 7px 0;
  :last-child {
    border: none;
  }
  transition: opacity .3s ease;
  opacity: ${({ hasActive, isActive }) =>
    hasActive ? (isActive ? 1 : 0.5) : 1};
`;
export const ListControls = s.div`
  margin-inline-start: auto;
  display: flex;
`;
